import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['place', 'contact']),
        getByContact: state => contact => {
            return state.objs.filter(cp => cp.contact == contact);
        },
        getByPlace: state => place => {
            return state.objs.filter(cp => cp.place == place);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['place', 'contact'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['place', 'contact'])
    },
}